import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, getformid, getcontroller, getsubkey } from '../modules/appLibrary';
import MasterBase from "../components/MasterLayout";
import { readonly } from '../modules/formstore';

export const Brand = props => {

    const dispatch = useDispatch();
    const formid = getformid("Brand", props.location.search);
    const controller = getcontroller("Brand", props.location.search);
    const subkey = getsubkey(props.location.search);
    const search = useLocation().search;

    const actionurl = {
        "insert": "brand/Insert",
        "update": "brand/Update",
        "delete": "brand/Delete",
        "saveas": "brand/SaveAs",
        "storageadd": "brand/AddStorage",
        "storagerowdel": "brand/StorageRowdel",
    }
    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]

    return (
        <div>
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                condition={false}
                navmenu={navmenu}
            />
        </div>
    );
};
